export const PRODUTO_COL_WIDE_PCT = 24;
export const PRODUTO_COL_MEDIUM_PCT = 20;
export const PRODUTO_COL_NARROW_PCT = 16;

export const PRODUTO_DESC_LONG = 45;
export const PRODUTO_DESC_MEDIUM = 30;

export const TABLE_WIDTH_PCT = 100;
export const OTHER_COLS_COUNT = 5;
